// AI Chat action types
export const AI_CHAT_LOADING = 'AI_CHAT_LOADING';
export const AI_CHAT_SUCCESS = 'AI_CHAT_SUCCESS';
export const AI_CHAT_ERROR = 'AI_CHAT_ERROR';

export const AI_CHAT_SET_REPLY = 'AI_CHAT_SET_REPLY';
export const AI_CHAT_CLEAR = 'AI_CHAT_CLEAR';

// Conversations and history
export const AI_CHAT_SET_CONVERSATION = 'AI_CHAT_SET_CONVERSATION';
export const AI_CHAT_ADD_HISTORY = 'AI_CHAT_ADD_HISTORY';
export const AI_CHAT_CLEAR_HISTORY = 'AI_CHAT_CLEAR_HISTORY';
export const AI_CHAT_CONVERSATIONS_LOADING = 'AI_CHAT_CONVERSATIONS_LOADING';
export const AI_CHAT_SET_CONVERSATIONS = 'AI_CHAT_SET_CONVERSATIONS';
export const AI_CHAT_CONVERSATIONS_ERROR = 'AI_CHAT_CONVERSATIONS_ERROR';
export const AI_CHAT_SET_CONVERSATION_MESSAGES =
  'AI_CHAT_SET_CONVERSATION_MESSAGES';
